import { useMsal } from '@azure/msal-react';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
// import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import PersonIcon from '@mui/icons-material/Person';
import { Box, IconButton, Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import HelloRefiLogo from '@/assets/images/hello-refi-logo.svg';
import { logout } from '@/store/reducers/authSlice';
import { Notistack } from '../../Notistack';
import { TopbarLogoWrapper } from './topbar.styles';

interface Props {
  onMenuClick: () => void;
}

export const Topbar = ({ onMenuClick }: Props) => {
  const { instance } = useMsal();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isHomePage = location.pathname === '/home';

  const navigateToHome = () => {
    navigate(`/home${location.search}`);
  };

  const navigateToProfile = () => {
    navigate(`/profile${location.search}`);
  };

  const handleLogout = () => {
    dispatch(logout());
    const redirectPath = window.location.search;

    sessionStorage.setItem(
      'postLoginRedirect',
      redirectPath
    );
    sessionStorage.removeItem('isUserCreated');
    instance
      .logoutRedirect({
        postLogoutRedirectUri: `${window.location.origin}/login`,
      })
      .catch((error) => {
        console.error('Logout failed:', error);
        Notistack.generalError('Logout failed');
        window.location.href = '/login';
      });
  };
  
  return (
    <Box
      sx={{
        height: {
          xs: '2.5rem',
          sm: '4rem',
          md: '5rem'
        },
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        backgroundColor: '#fff',
        borderBottom: '1px solid #E5E7EB',
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        zIndex: 1200,
      }}
    >

      <IconButton onClick={onMenuClick}>
        <MenuIcon />
      </IconButton>

      <TopbarLogoWrapper>
        <img
          src={HelloRefiLogo}
          alt="hello-refi-logo"
        />
      </TopbarLogoWrapper>

      <Box sx={{ display: 'flex', gap: 2, ml: 'auto' }}>
        {/* <NotificationsNoneIcon sx={{color: '#00aa8f'}} /> */}
        {!isHomePage && (<Tooltip title="Back To Home">
          <HomeIcon sx={{ color: '#00aa8f', cursor: 'pointer' }} onClick={navigateToHome} />
        </Tooltip>
        )}
        <Tooltip title="View Profile">
          <PersonIcon sx={{ color: '#00aa8f', cursor: 'pointer' }} onClick={navigateToProfile} />
        </Tooltip>
        <Tooltip title="Logout">
          <LogoutIcon sx={{ color: '#00aa8f', cursor: 'pointer' }} onClick={handleLogout} />
        </Tooltip>
      </Box>
    </Box>
  );
};
